export default "__VITE_ASSET__CY_uENS7__"